// Detect Andriod.
(function() {
  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
  if(isAndroid) {
    var DHtml = document.getElementsByTagName('html')[0];
    var _className = DHtml.getAttribute('class');
    DHtml.setAttribute('class', _className + ' ANDRIOD');
  }
})();


//////////////////
// WEBPACK FOOTER
// ./src/app/utilities/detect-andriod.js
// module id = 1343
// module chunks = 22